<div class="controls" *ngIf="!isLoading">
    <div class="plan-actions" role="list">
            <button type="button" mat-raised-button role="menu" color="primary" class="buttonClass download-menu-btn" [matMenuTriggerFor]="downloadMenu" [disabled]="isDownloadingPdf" aria-label="Download Plan" role="listitem">
                <span *ngIf="!isDownloadingPdf">DOWNLOAD PLAN</span>
                <span *ngIf="isDownloadingPdf">GENERATING PLAN...</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #downloadMenu="matMenu" class="download-menu" yPosition="below">
                <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf(false)" class="buttonClass">Full Plan (PDF)</button>
                <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf(true)" class="buttonClass">Simplified Plan (PDF)</button>
                <button appNoDblClick type="button" mat-menu-item (click)="downloadPdf()" class="buttonClass">Both Plans (PDFs)</button>
            </mat-menu>

            <button type="button" mat-raised-button role="menu" color="primary" class="buttonClass email-menu-btn" [matMenuTriggerFor]="emailMenu" [disabled]="isSendingPdfEmail" aria-label="Email Plan" role="listitem">
                <span *ngIf="!isSendingPdfEmail">EMAIL PLAN</span>
                <span *ngIf="isSendingPdfEmail">EMAILING PLAN...</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
            <span class="material-symbols-outlined email-tooltip" matTooltipPosition="right" [matTooltip]="'The selected CPD plan(s) will be emailed to ' + (profile?.member?.email_no || '') +  '. If you want to change your email address, you will need to close this CPD Tool to edit your personal information in the Lawyer Portal. Close the CPD Tool and open the Lawyer Portal.'">
                info
            </span>
            <mat-menu #emailMenu="matMenu" class="email-menu" yPosition="below">
                <button appNoDblClick type="button" mat-menu-item (click)="emailPdf(false)" class="buttonClass">Full Plan (PDF)</button>
                <button appNoDblClick type="button" mat-menu-item (click)="emailPdf(true)" class="buttonClass">Simplified Plan (PDF)</button>
                <button appNoDblClick type="button" mat-menu-item (click)="emailPdf()" class="buttonClass">Both Plans (PDFs)</button>
            </mat-menu>
        <div *ngIf="plan?.IsEditable" role="listitem"><button appNoDblClick type="button" class="edit-btn"  mat-raised-button color="primary" (click)="editPlan()">Edit My Plan</button></div>
    </div>
</div>



<h1>{{plan?.IsEditable ? "View/Edit Plan" : "View Plan"}}</h1>
<div class="clearfix"></div>
<small *ngIf="plan?.IsEditable">To remove compentencies or edit/remove activities from your plan, go to the <button class="edit-learning" (click)="editLearning()">Set your learnings activities step</button>. If you want to add or edit competencies, use the "Edit My Plan" button.</small>
<mat-card appearance="outlined" class="sharp main">
    <mat-card-content>
        <div class="spinner" *ngIf="isLoading">
            <mat-spinner color="primary"></mat-spinner>
        </div>
        <div *ngIf="plan && !isLoading">
            <p class="align-left">Your current plan</p>
            <p class="align-right pad" *ngIf="lastEditedDate">Last edited: {{lastEditedDate}}</p>
            <p class="align-right" *ngIf="submittedDate">Submitted: {{submittedDate}}</p>

            <div class="clear"></div>
            <mat-card appearance="outlined" class="inner" *ngFor="let competency of plan.Competencies; let i = index">
                <h4>Competency {{i+1}}: {{competency.Name}}</h4>
                <span class="domain">DOMAIN: {{competency.Domain.toLocaleUpperCase()}}</span>
                <br/>
                <span class="domain">SELF-ASSESSMENT PROFICIENCY RATING: </span>
                    <span class="proficiency-rating">{{competency.Rating.toLocaleUpperCase()}}</span>

                <div class="activity-item" *ngFor="let activity of competency.Activities">
                    <small>Activity</small>
                    <span class="activity-name">{{activity.ActivityTemplate.Name === 'Other' ? activity.Description :
                        activity.ActivityTemplate.Name}}</span>
                </div>
                <div class="activity-item">
                    <small>Notes About Learning Activities</small>
                    <span class="activity-name">{{competency.ActivityNote}}</span>
                </div>
            </mat-card>
        </div>
    </mat-card-content>
</mat-card>
